import axios from '@/api/requests/axios'

export default {
  getAllForRestaurant: (params) => axios.get(`/api/admin/v1/menu-versions`, { params }),
  syncForRestaurant: (restaurant) => axios.put(`/api/admin/v1/menu-versions/sync`, restaurant),
  syncForRestaurants: (restaurants) => axios.put(`/api/admin/v1/menu-versions/sync-all`, restaurants),
  activate: (menuVersion) => axios.put(`/api/admin/v1/menu-versions/activate`, menuVersion)
}
